import { queryOptions, useQuery } from '@tanstack/react-query';

import { operationsApi } from '../api/operations-api';

import { operationsKeys } from './operations-keys';

export const OPS_REFRESH_MS = 30_000;

export function opsOverviewQueryOptions() {
  return queryOptions({
    queryKey: operationsKeys.overview(),
    queryFn: () => operationsApi.overview(),
  });
}

/** Refreshes every 30 s while the page is open, and on focus. */
export function useOpsOverview() {
  return useQuery({ ...opsOverviewQueryOptions(), refetchInterval: OPS_REFRESH_MS });
}
